module.exports = __webpack_public_path__ + "media/flags/va-8a8af6ad.svg";